import { useEffect } from "react";

// Lightweight per-route <title> and meta description, no router-meta library needed for a
// small site. Every routed page calls this on mount, so there's nothing to restore on
// unmount - the next page mounting always sets its own title right after. A page that
// passes no description gets the site-wide default from index.html back, so one page's
// description never lingers on the next.
export function usePageTitle(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Groundwork TierUp` : "Groundwork TierUp";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      if (!meta.dataset.defaultContent) meta.dataset.defaultContent = meta.content;
      meta.content = description || meta.dataset.defaultContent;
    }
  }, [title, description]);
}
